import React from 'react'
import { Redirect, Route } from 'react-router-dom'
export const CentralAdminPRivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem('user-native') ? (
        JSON.parse(localStorage.getItem('user-native')).userType ===
        1 ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: props.location }
            }}
          />
        )
      ) : (
        <Redirect
          to={{
            pathname: '/auth/login',
            state: { from: props.location }
          }}
        />
      )
    }
  />
)
